import React from "react";
import { connect } from "react-redux";
import { submissionErrorHandler } from "../submissionErrorHandler";
import Component from "./component";
import { reduxForm } from "redux-form";
import { loginUserCode } from "api/users";
import { loginUserSuccess } from "containers/Auth/actions";

import * as api from "api/auth";
import { compose } from "redux";
import DonorForm from "../create-update-donor/create-update-donor-form.component";

const mapStateToProps = (state, ownProps) => ({
  initialValues: {
    phoneNumber: ownProps.phoneNumber,
  },
});

const validate = (values) => {
  const errors = {};
  //
  // //Only checking for entry into required fields
  // let requiredFields = ['address', 'city']
  // validateEmpty(errors, values, requiredFields)
  //
  // validZipcode(errors, values, 'zip')
  // validState(errors, values, 'state')

  return errors;
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSubmit: (form) =>
      api
        .loginUserCode(form)
        .then((response) => {
          dispatch(loginUserSuccess(response.data.data[0]));
        })
        .catch((err) =>
          submissionErrorHandler(err, "Code was incorrect. Please try again.")
        ),
  };
};

// Connect to the store using a container component
const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withForm = reduxForm({ form: "LoginCode", validate });

export default compose(withConnect, withForm)(Component);
